import { Box, Tab, Tabs } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { GifColors } from "../../../theme";

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "85%",
      backgroundColor: GifColors.darkBlue,
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export const StyledTab = withStyles((theme) => ({
  selected: {
    color: GifColors.israelBlue,
  },
}))((props) => <Tab disableRipple {...props} />);
